import React from "react";

import {
  Pagination as MuiPagination,
  PaginationProps,
  css,
  styled,
} from "@mui/material";

import { skipForwardProp } from "@/utils/skipForwardProp";

type PropTypes = PaginationProps & {
  hideLastPagePaginationButton?: boolean;
  setPage: (pageNumber: number) => void;
  page: number;
  count: number | undefined;
};

export const Pagination: React.FC<PropTypes> = ({
  hideLastPagePaginationButton = false,
  count,
  page,
  setPage,
  ...rest
}) => {
  return (
    <>
      {count && count > 1 ? (
        <StyledPagination
          color="primary"
          page={page}
          count={count}
          onChange={(_e, pageNumber) => {
            setPage(pageNumber);
          }}
          hideLastPagePaginationButton={hideLastPagePaginationButton}
          {...rest}
        />
      ) : null}
    </>
  );
};

const StyledPagination = styled(MuiPagination, {
  shouldForwardProp: skipForwardProp(["hideLastPagePaginationButton"]),
})<Omit<PropTypes, "setPage">>(({ theme, hideLastPagePaginationButton }) => {
  return css`
    & .MuiPaginationItem-root.Mui-selected:hover {
      background-color: ${theme.palette.blue.main};
    }

    ${hideLastPagePaginationButton
      ? css`
          li:has(button.Mui-selected)
            ~ li:has(div)
            + li:has(button.MuiPaginationItem-page) {
            display: none;
          }
        `
      : ""}
  `;
});
